// schemas.ts
import { date, z } from 'zod';

// export const deliveryFormSchema = z.object({
//   delivery_id: z.string().min(1, "Delivery ID is required"),
//   delivery_mode: z.enum(['Online', 'Offline']),
//   products: z.array(z.string()).min(1, "At least one product is required"),
//   customers: z.array(z.number()).min(1, "At least one customer is required"),
//   delivery_channel: z.string().min(1, "Delivery channel is required"),
//   address1: z.string().min(1, "Address 1 is required"),
//   address2: z.string().optional(),
//   city: z.string().min(1, "City is required"),
//   state: z.string().min(1, "State is required"),
//   country: z.string().min(1, "Country is required"),
//   landmark: z.string().optional(),
//   pincode: z.string().min(6, "Pincode must be at least 6 characters"),
// });

// export type DeliveryFormSchema = z.infer<typeof deliveryFormSchema>;
// types.ts
export type DeliveryStatus = 'Pending' | 'Ready to deliver' | 'Delivered';
export type DeliveryMode = 'Self' | 'Courier' | 'Pickup' | '';

export interface Product {
  product_name: string;
  currency: string;
  quantity: number;
}

export interface TabData {
  [customerName: string]: AllDeliveryData[];
}

// For "All" tab which has a slightly different structure
export interface AllDeliveryData {
  contacts_id: number;
  delivery_mode: string;
  delivery_id: string;
  generic_order_product_id: string;
  delivery_channel: string;
  Status: string;
  adress: string;
  contactName: string;
  contactNumber: string;
}

export interface DeliveryFormData {
  delivery_id: string;
  delivery_mode: DeliveryMode;
  product_type: string;
  currency_code: string;
  quantity: number;
  customer_name: string;
  delivery_channel: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  pincode: string;
}

export const deliveryFormSchema = z.object({
  delivery_id: z.string().min(1, "Delivery ID is required"),
  delivery_mode: z.enum(['self', 'courier', 'pickup']),
  products: z.array(z.string()).min(1, "At least one product is required"),
  customers: z.array(z.number()).min(1, "At least one customer is required"),
  delivery_channel: z.string().optional(),
  address1: z.string().min(1, "Address 1 is required"),
  address2: z.string().optional(),
  city: z.string().min(1, "City is required"),
  state: z.string().min(1, "State is required"),
  country: z.string().min(1, "Country is required"),
  landmark: z.string().optional(),
  pincode: z.string().min(6, "Pincode must be at least 6 characters"),
  address_id: z.string().optional(),
})

export type DeliveryFormSchema = z.infer<typeof deliveryFormSchema>;

export const deliveryStatusSchema = z.object({
  status: z.string(),
  date: z.string().optional(),
  quantity: z.number().optional()
})

export type DeliveryStatusSchema = z.infer<typeof deliveryStatusSchema>;